import { useMutation, useQueryClient } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"

import { deleteSalesforceIntegration, getSalesforceAuthUri } from "./api"

export function useGetSalesforceAuthUri() {
  const getContext = useApiContext()

  return useMutation({
    mutationFn: async () => {
      const context = await getContext()
      return getSalesforceAuthUri(context)
    },
  })
}

export function useDeleteSalesforceIntegration() {
  const getContext = useApiContext()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async () => {
      const context = await getContext()
      return deleteSalesforceIntegration(context)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["salesforce-integration"] })
    },
  })
}
